// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BrandsBlock_wrapper__PonM8","brandsBlock":"BrandsBlock_brandsBlock__vfPlV","heading":"BrandsBlock_heading__sgQUv","grid__item":"BrandsBlock_grid__item__t5HYa"};